var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle, _ellipse, _path34, _path35, _path36, _path37, _path38, _rect, _rect2, _path39, _rect3, _rect4, _rect5, _rect6, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlluNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4622750-6c47-4033-a91b-dc69f69d9c4e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 853 603.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add notes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M899.22,155.09H743.52a543.76,543.76,0,0,0,0,192.93c45.59-8,98.57-6.6,155.7,0C887.63,282.3,887.1,217.92,899.22,155.09Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.1,742c3-5.51-.4-12.26-4.29-17.18s-8.61-10-8.51-16.29c.15-9,9.7-14.31,17.33-19.08a84,84,0,0,0,15.56-12.51,23,23,0,0,0,4.78-6.4c1.58-3.52,1.54-7.52,1.44-11.38q-.51-19.26-1.91-38.48",
    transform: "translate(-173.5 -148.09)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256,619.93a14,14,0,0,0-7-11.5l-3.14,6.21.1-7.52a14,14,0,1,0,10,12.81Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231,714.92a14,14,0,1,1,.68-11.3l-8.77,7.13,9.65-2.23A14,14,0,0,1,231,714.92Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.05,687.67a14,14,0,0,1-4.45-27.54l-.08,5.79,3.18-6.29h0A14,14,0,0,1,237.41,673a13.84,13.84,0,0,1-.6,4.79A14,14,0,0,1,224.05,687.67Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.12,665a14,14,0,1,1,6.21-26.27l-2.48,6.8,5.1-4.9a14,14,0,0,1,4.53,9.69,13.69,13.69,0,0,1-.35,3.86A14.05,14.05,0,0,1,258.12,665Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.12,623.66c-3.24.36-6.39,1.37-9.64,1.57s-6.82-.58-8.88-3.1c-1.1-1.37-1.66-3.09-2.59-4.57a10,10,0,0,0-3.54-3.33,14,14,0,1,0,26.24,9.32C255.18,623.57,254.65,623.61,254.12,623.66Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M258.12,665a14,14,0,0,1-13.35-20,10.4,10.4,0,0,1,2.82,2.83c1,1.51,1.61,3.25,2.78,4.64,2.19,2.57,5.92,3.41,9.31,3.25s6.66-1.11,10-1.42c.47,0,.94-.07,1.42-.09A14.05,14.05,0,0,1,258.12,665Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.05,687.67a14,14,0,0,1-13.46-19.76,11.48,11.48,0,0,1,3,2.85c1.09,1.54,1.77,3.31,3,4.73,2.37,2.64,6.35,3.57,9.93,3.48s6.83-.93,10.28-1.19A14,14,0,0,1,224.05,687.67Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231,714.92a14,14,0,0,1-25.59-11.45,13.8,13.8,0,0,1,3.08,2.74c1.34,1.63,2.22,3.47,3.76,5,2.87,2.82,7.5,4,11.63,4.09A62.17,62.17,0,0,0,231,714.92Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.93,739.61s11.08-4.34,14.42-6.72,17-5.22,17.86-1.4,16.65,19,4.15,19.06-29.06,2.05-32.4,0S195.93,739.61,195.93,739.61Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#656380"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232.58,749.22c-12.51.1-29.06,2-32.39,0-2.54-1.54-3.55-7.09-3.89-9.65l-.37,0s.7,8.93,4,11,19.89.08,32.4,0c3.61,0,4.85-1.31,4.78-3.22C236.64,748.48,235.27,749.2,232.58,749.22Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M990.77,737.59c-4.74-8.78.64-19.54,6.82-27.37s13.73-16,13.57-26c-.23-14.35-15.45-22.81-27.62-30.42a134.77,134.77,0,0,1-24.79-19.93c-3-3-5.87-6.31-7.62-10.2-2.52-5.61-2.45-12-2.29-18.13q.79-30.71,3-61.34",
    transform: "translate(-173.5 -148.09)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M928.76,543.12a22.31,22.31,0,0,1,11.16-18.32l5,9.9-.15-12a22.37,22.37,0,1,1-16,20.41Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M968.64,694.51a22.36,22.36,0,1,0-1.08-18l14,11.37-15.37-3.57A22.25,22.25,0,0,0,968.64,694.51Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M979.69,651.08a22.37,22.37,0,0,0,7.09-43.88l.12,9.22-5.06-10h-.06a22.37,22.37,0,1,0-2.09,44.69Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M925.39,615a22.37,22.37,0,1,0-9.89-41.86l4,10.83-8.13-7.8A22.37,22.37,0,0,0,925.39,615Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#57b894"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M931.76,549.08c5.17.57,10.19,2.18,15.37,2.5s10.87-.92,14.14-5c1.77-2.17,2.65-4.91,4.14-7.28a16.06,16.06,0,0,1,5.63-5.3,22.37,22.37,0,1,1-41.81,14.85C930.08,548.93,930.92,549,931.76,549.08Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M925.39,615A22.39,22.39,0,0,0,946.67,583a16.51,16.51,0,0,0-4.5,4.51c-1.59,2.4-2.56,5.18-4.43,7.39-3.48,4.09-9.44,5.43-14.84,5.19s-10.6-1.78-16-2.28c-.75-.06-1.5-.11-2.26-.13A22.37,22.37,0,0,0,925.39,615Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M979.69,651.08a22.37,22.37,0,0,0,21.46-31.49,17.83,17.83,0,0,0-4.73,4.55c-1.74,2.45-2.82,5.27-4.86,7.54-3.77,4.2-10.11,5.68-15.83,5.54-5.54-.12-10.87-1.48-16.38-1.9A22.36,22.36,0,0,0,979.69,651.08Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M968.64,694.51a22.37,22.37,0,0,0,40.78-18.25,22.27,22.27,0,0,0-4.91,4.38c-2.13,2.59-3.53,5.53-6,7.94-4.57,4.49-11.95,6.34-18.52,6.51A97.1,97.1,0,0,1,968.64,694.51Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.5,731.48s-17.65-4.54-23-8.33-27.16-8.31-28.48-2.24-26.53,30.22-6.6,30.38,46.31.9,51.62-2.34S1024.5,731.48,1024.5,731.48Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#656380"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M966.1,749.18c19.93.16,46.31.89,51.62-2.34,4-2.47,5.65-11.3,6.19-15.38l.59,0s-1.12,14.24-6.43,17.47-31.69,2.5-51.62,2.34c-5.75,0-7.74-2.09-7.63-5.12C959.62,748,961.81,749.14,966.1,749.18Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M416.89,159.94H261.19c12.13,62.83,11.59,127.21,0,192.93,57.13-6.6,110.12-8,155.7,0A543.76,543.76,0,0,0,416.89,159.94Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M568.52,243.37c-15.2,1.08-29.46,11.7-30.5,25.47-.57,7.49,2.56,15.13,1.29,22.52-1.67,9.78-10.63,17-20,21.91s-19.73,8.61-27.52,15.37-12.35,18-6.85,26.81c2.11,3.38,5.44,6,8.14,9,7.34,8.23,9.82,19.74,6.36,29.51-3.15,8.85-10.83,16.65-10,26.05.8,9,9.59,16.3,19.11,19.15s19.7,2.18,29.55,1.47c11.37-.81,24.12-2.29,30.73-10.53,7.1-8.85,3.93-21.6,7.71-32.06,7.54-20.84,38.73-25.91,51.19-44.56,6-9,6.91-20.09,6.82-30.77C634.29,288.89,616.15,240,568.52,243.37Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M566,316.31s5,16-12,25,14,31,14,31l24,9,27-12-5-41s-23,8-23-21Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#a0616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M566,316.31s5,16-12,25,14,31,14,31l24,9,27-12-5-41s-23,8-23-21Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M603,676.31s-5,34-2,38,17,2,17,2,3-34,4-38S603,676.31,603,676.31Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#a0616a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M618.51,710.63S604,708.31,604,712.31c0,0-6,3-6,0s-5.5,31.5-1.5,36.5,19.28-.48,23,2c3,2,25.5,1.5,26.5-3.5s1-9-8-14S618.51,710.63,618.51,710.63Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M618.51,710.63S604,708.31,604,712.31c0,0-6,3-6,0s-5.5,31.5-1.5,36.5,19.28-.48,23,2c3,2,25.5,1.5,26.5-3.5s1-9-8-14S618.51,710.63,618.51,710.63Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M568,673.31s7,30,4,44l21-6s-13-35-12-38S568,673.31,568,673.31Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#a0616a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M576,711.31s13-7,17,0,16,35,9,38-29,2-30-9-2-27-2-27S575,715.31,576,711.31Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M540,455.31s-19,39,5,101c0,0,12,36,6,57s13,70,13,70l23-4s-9-66-6-73,1-82,1-82,27,51,23,92-5,64-5,64l26-1a402,402,0,0,1,8-41c5-19,8-109-5-136l-3-33Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 153.21,
    r: 24,
    fill: "#a0616a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 571.5,
    cy: 286.81,
    rx: 28,
    ry: 15,
    transform: "translate(-205.3 -73.17) rotate(-7.3)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M599.19,282.81c-1.32,7.31-12,14.12-25.78,15.88-15.06,1.93-28.14-2.93-29.6-10.88a8.14,8.14,0,0,0-.08,2.56c1,8.21,14.34,13.28,29.68,11.32s26.92-10.22,25.86-18.44C599.25,283.1,599.22,283,599.19,282.81Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M538.76,345.25c-3.22-1.33-6.92.73-9.08,3.46s-3.4,6.1-5.53,8.85c-2.4,3.08-5.79,5.2-8.95,7.51a75.74,75.74,0,0,0-11.37,10.25c-1.82,2-3.59,4.18-6,5.52-3.83,2.15-8.67,1.77-12.71,0s-7.43-4.63-10.74-7.51Q459.62,360.46,445.26,347c-6.81-6.36-16.62-9.56-25.88-10.58-2.26-.25-4.81-.26-6.49,1.27a5.92,5.92,0,0,0-1.73,4.18c-.21,5.21,4.22,9.55,9,11.66s10.08,2.75,14.89,4.75a29.13,29.13,0,0,1,11.63,8.88c3.36,4.28,7.43,7.78,10.63,12.17,1.46,2,2.75,4.11,4.15,6.15A134.78,134.78,0,0,0,472.54,399c4.63,5.15,10.29,10.73,17.19,10.21,2.88-.21,5.54-1.5,8.13-2.77,8.09-4,16.25-8,23.34-13.55,4.15-3.25,7.9-7,12.25-10,4.16-2.85,8.91-5,12.28-8.77a18.26,18.26,0,0,0,4.06-16.2A18.93,18.93,0,0,0,538.76,345.25Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#a0616a"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M630.24,335.25c3.22-1.33,6.92.73,9.08,3.46s3.4,6.1,5.53,8.85c2.4,3.08,5.79,5.2,8.95,7.51a75.74,75.74,0,0,1,11.37,10.25c1.82,2,3.59,4.18,6,5.52,3.83,2.15,8.67,1.77,12.71,0s7.43-4.63,10.74-7.51q14.8-12.92,29.16-26.33c6.81-6.36,16.62-9.56,25.88-10.58,2.26-.25,4.81-.26,6.49,1.27a5.92,5.92,0,0,1,1.73,4.18c.21,5.21-4.22,9.55-9,11.66s-10.08,2.75-14.89,4.75a29.13,29.13,0,0,0-11.63,8.88c-3.36,4.28-7.43,7.78-10.63,12.17-1.46,2-2.75,4.11-4.15,6.15A134.78,134.78,0,0,1,696.46,389c-4.63,5.15-10.29,10.73-17.19,10.21-2.88-.21-5.54-1.5-8.13-2.77-8.09-4-16.25-8-23.34-13.55-4.15-3.25-7.9-7-12.25-10-4.16-2.85-8.91-5-12.28-8.77a18.26,18.26,0,0,1-4.06-16.2A18.93,18.93,0,0,1,630.24,335.25Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#a0616a"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M590,365.31a188.72,188.72,0,0,0-17-10c-8-4-17-17-17-17s-28,5-28,12,12,32,16,34,10,2,9,6,3,12,3,12,8,12,3,15-27,39-24,44,31,10,45,22,53-1,53-4-4-9-4-9-1-50,4-66,1-39-1-42c0,0,12-21,7-27s-29-9-31-8l-1.89,10.89a88.09,88.09,0,0,1-6.91,22c-1,2.17-1.87,4.11-2.2,5.09C596,368.31,590,365.31,590,365.31Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#4b55f6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M737.52,341c45.59-8,98.57-6.6,155.7,0-11.59-65.72-12.12-130.1,0-192.93H737.52A543.76,543.76,0,0,0,737.52,341Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 589.5,
    y: 32.43,
    width: 96,
    height: 13,
    fill: "#4b55f6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 589.5,
    y: 59.43,
    width: 96,
    height: 13,
    fill: "#4b55f6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M423.89,344.87c-45.58-8-98.57-6.6-155.7,0,11.59-65.72,12.13-130.1,0-192.93h155.7A543.76,543.76,0,0,1,423.89,344.87Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 39.43,
    width: 96,
    height: 13,
    fill: "#4b55f6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 601.71,
    width: 657,
    height: 2,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 601.71,
    width: 80,
    height: 2,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 601.71,
    width: 80,
    height: 2,
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M397.65,473.93a14,14,0,0,0-7-11.5l-3.14,6.21.09-7.52a13.86,13.86,0,0,0-4.62-.56,14,14,0,1,0,14.68,13.37Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#f2f2f2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M395.76,477.66c-3.24.36-6.39,1.37-9.64,1.57s-6.82-.58-8.88-3.1c-1.1-1.37-1.66-3.09-2.59-4.57a10,10,0,0,0-3.54-3.33,14,14,0,1,0,26.24,9.32C396.82,477.57,396.29,477.61,395.76,477.66Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.03
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M740.16,609.68A14,14,0,0,0,726.75,611l4.22,5.54-6.73-3.37a13.86,13.86,0,0,0-2.51,3.91,14,14,0,1,0,18.43-7.37Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#f2f2f2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M742.7,613c-1.1,3.07-1.56,6.34-2.8,9.36s-3.5,5.88-6.67,6.63c-1.71.4-3.5.15-5.24.34a10,10,0,0,0-4.54,1.73,13.87,13.87,0,0,0,5.65,4.41,14,14,0,0,0,14.18-24C743.07,612,742.88,612.51,742.7,613Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.03
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M690.46,175.32a14,14,0,0,0-13.47-.11l3.63,5.95-6.35-4a14,14,0,1,0,16.19-1.79Z",
    transform: "translate(-173.5 -148.09)",
    fill: "#f2f2f2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M692.64,178.9c-1.4,2.93-2.21,6.14-3.75,9s-4.08,5.49-7.31,5.91c-1.74.22-3.5-.21-5.25-.2a10,10,0,0,0-4.7,1.25,13.88,13.88,0,0,0,5.17,5,14,14,0,0,0,16.58-22.36C693.12,178,692.87,178.42,692.64,178.9Z",
    transform: "translate(-173.5 -148.09)",
    opacity: 0.03
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluNotes);
export default __webpack_public_path__ + "static/media/illu-notes.7862e81e3dbbf320f2420befaa6c2b8c.svg";
export { ForwardRef as ReactComponent };